export const reportTypes = [
    { name: 'General Information', value: 'generalinformation', multiVehicle: true, minStopDrive: true },
    { name: 'Drive and Stop', value: 'driveandstop', mapOption: true, minStopDrive: true },
    /*{ name: 'Travel Sheet', value: 'travelsheet', mapOption: true, minStopDrive: true },*/
    { name: 'Zone', value: 'zone', multiVehicle: true, zoneSelect: true },
    { name: 'Over Speed', value: 'overspeed', mapOption: true, speedLimit: true, compliance: true },

    { name: 'Engine', value: 'binarysensor', minActive: true, compliance: true, mapOption: true, },
    { name: 'Generator', value: 'binarysensor', minActive: true, compliance: true, mapOption: true, },
    { name: 'Genset Wire', value: 'binarysensor', minActive: true, compliance: true, mapOption: true, eventName: 'Gen Wire', },
    { name: 'Generator Fleet', value: 'genfleet', multiVehicle: true },

    { name: 'Temperature', value: 'tempbasic', minTemp: true, maxTemp: true, compliance: true, mapOption: true, interval: true },
    { name: 'Temperature Range', value: 'temprange', minTemp: true, maxTemp: true, compliance: true, mapOption: true, interval: true },
    { name: 'AC', value: 'binarysensor', minActive: true, compliance: true, mapOption: true, },
    { name: 'Door', value: 'binarysensor', minActive: true, compliance: true, mapOption: true, },
    { name: 'Compressor', value: 'binarysensor', minActive: true, compliance: true, mapOption: true, },
    { name: 'Blower', value: 'binarysensor', minActive: true, compliance: true, mapOption: true, },

    { name: 'Fuel Fill & Theft', value: 'fuelfillntheft', multiVehicle: true, minStopDrive: false },
    { name: 'Fuel Consumption', value: 'fuelconsumption', multiVehicle: true, minStopDrive: false, mapOption: false },
    /*{ name: 'Fuel High Burn', value: 'fuelhighburn', multiVehicle: true, minStopDrive: true, mapOption: true, },*/
    { name: 'Fuel Summary', value: 'fuelsummary', multiVehicle: true, minStopDrive: false, mapOption: false, },
    { name: 'Fuel Detailed Activity', value: 'fuelactivity', minStopDrive: false, mapOption: false, },
    { name: 'Fuel Advanced', value: 'fuelactivityadvanced', minStopDrive: false, mapOption: false, },
    /*{ name: 'Drive and Stop with Fuel', value: 'driveandstopfuel', minStopDrive: true, mapOption: true, },*/
    { name: 'Trips with Fuel', value: 'shinytripfuel', minStopDrive: false, mapOption: false, },
    { name: 'Trip Violations', value: 'tripviolations', minStopDrive: false, mapOption: false, routeSelection: true,multiVehicle: true, ruleSelection: true},
    { name: 'Trip Log', value: 'triplog', minStopDrive: false, mapOption: false, routeSelection: true,multiVehicle: true,},



];


export const defaultReport = [
    { name: 'General Information', value: 'generalinformation', multiVehicle: true, minStopDrive: true },
    { name: 'Drive and Stop', value: 'driveandstop', mapOption: true, minStopDrive: true },
    { name: 'Generator Fleet', value: 'genfleet', multiVehicle: true },
];

export const advancedReports = [
    /*{ name: 'Travel Sheet', value: 'travelsheet', mapOption: true, minStopDrive: true },*/
    { name: 'Zone', value: 'zone', multiVehicle: true, zoneSelect: true },
    { name: 'Over Speed', value: 'overspeed', mapOption: true, speedLimit: true, compliance: true },

    { name: 'Engine', value: 'binarysensor', minActive: true, compliance: true, mapOption: true, },
    { name: 'Generator', value: 'binarysensor', minActive: true, compliance: true, mapOption: true, },

    { name: 'Temperature', value: 'tempbasic', minTemp: true, maxTemp: true, compliance: true, mapOption: true, interval: true },
    { name: 'Temperature Range', value: 'temprange', minTemp: true, maxTemp: true, compliance: true, mapOption: true, interval: true },

    { name: 'AC', value: 'binarysensor', minActive: true, compliance: true, mapOption: true, },
    { name: 'Door', value: 'binarysensor', minActive: true, compliance: true, mapOption: true, },
    { name: 'Compressor', value: 'binarysensor', minActive: true, compliance: true, mapOption: true, },
    { name: 'Blower', value: 'binarysensor', minActive: true, compliance: true, mapOption: true, },

    { name: 'Fuel Fill & Theft', value: 'fuelfillntheft', multiVehicle: true, minStopDrive: false },
    { name: 'Fuel Consumption', value: 'fuelconsumption', multiVehicle: true, minStopDrive: false, mapOption: false },
    /*{ name: 'Fuel High Burn', value: 'fuelhighburn', multiVehicle: true, minStopDrive: true, mapOption: true, },*/
    { name: 'Fuel Summary', value: 'fuelsummary', multiVehicle: true, minStopDrive: false, mapOption: false, },
    { name: 'Fuel Detailed Activity', value: 'fuelactivity', minStopDrive: false, mapOption: false, },
    /*{ name: 'Drive and Stop with Fuel', value: 'driveandstopfuel', minStopDrive: true, mapOption: true, },*/
    { name: 'Trips with Fuel', value: 'shinytripfuel', minStopDrive: false, mapOption: false, },
    { name: 'Trip Violations', value: 'tripviolations', minStopDrive: false, mapOption: false, routeSelection: true,multiVehicle: true, ruleSelection: true},
    { name: 'Trip Log', value: 'triplog', minStopDrive: false, mapOption: false, routeSelection: true,multiVehicle: true,},
];
